import React, { useState, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';
import { SEOHead } from '../components/site/SEOHead';
import api from '../lib/api';

export default function FAQ() {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState(null);

  useEffect(() => { api.get('/faqs?active_only=true').then(r => setFaqs(r.data)).catch(() => {}).finally(() => setLoading(false)); }, []);

  const categories = [...new Set(faqs.map(f => f.category).filter(Boolean))];
  const grouped = categories.length > 0 ? categories.map(cat => ({ cat, items: faqs.filter(f => f.category === cat) })) : [{ cat: '', items: faqs }];

  return (
    <div data-testid="faq-page">
      <SEOHead title="Sıkça Sorulan Sorular" />
      <div className="relative py-16 md:py-24 bg-[#0f1419]">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white">Sıkça Sorulan Sorular</h1>
          <div className="mt-4 w-16 h-1 rounded-full bg-[hsl(var(--gold))]" />
        </div>
      </div>

      <section className="py-14 md:py-20">
        <div className="max-w-3xl mx-auto px-4 sm:px-6">
          {loading ? <div className="flex justify-center py-20"><div className="w-8 h-8 border-2 border-[hsl(var(--gold))] border-t-transparent rounded-full animate-spin" /></div>
          : faqs.length === 0 ? <div className="text-center py-20 text-muted-foreground">Henüz SSS eklenmemiş</div>
          : grouped.map((group, gi) => (
            <div key={gi} className="mb-8">
              {group.cat && <h2 className="font-heading text-xl font-semibold mb-4">{group.cat}</h2>}
              <div className="space-y-2">
                {group.items.map(f => (
                  <div key={f.id} className="rounded-xl border border-border overflow-hidden">
                    <button onClick={() => setExpanded(expanded===f.id?null:f.id)} className="flex items-center justify-between w-full p-4 text-left">
                      <span className="font-medium text-sm pr-4">{f.question}</span>
                      <ChevronDown className={`w-4 h-4 shrink-0 text-muted-foreground transition-transform ${expanded===f.id ? 'rotate-180' : ''}`} />
                    </button>
                    {expanded===f.id && <div className="px-4 pb-4 text-sm text-muted-foreground leading-relaxed whitespace-pre-line">{f.answer}</div>}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
